// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck nx global declarations issue (only on build/serve)import React from 'react'

import styled from '@emotion/styled'
import { IconButton, Tooltip, type IconButtonProps } from '@mui/material'
import {
    FirstPage as FirstPageIcon,
    LastPage as LastPageIcon,
    KeyboardArrowLeft as KeyboardArrowLeftIcon,
    KeyboardArrowRight as KeyboardArrowRightIcon,
} from '@mui/icons-material'
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions'
import { useIsMobile } from '@edge/spark/ui-mui'

const Container = styled.div`
    flex-shrink: 0;
    margin: 0 20px;
    ${({ theme }) => /* css */ `
        ${theme.breakpoints.only('xs')} {
            position: absolute;
            right: 0;
            margin: 0;
            display: flex;
            justify-content: space-evenly;
            width: 50%;
            bottom: 0;
            padding: 4px 0;
        }
  `}
`

type ClickHandler = IconButtonProps['onClick']

const TablePaginationActions: React.FC<TablePaginationActionsProps> = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onChangePage,
}: TablePaginationActionsProps) => {
    const mobile = useIsMobile()

    const handleFirstPageButtonClick: ClickHandler = (e) => {
        if (typeof onPageChange === 'function') {
            onPageChange(e, 0)
        } else {
            console.warn('Mui Deprecation Warning')
            onChangePage(e, 0)
        }
    }
    const handleBackButtonClick: ClickHandler = (e) => {
        if (typeof onPageChange === 'function') {
            onPageChange(e, page - 1)
        } else {
            console.warn('Mui Deprecation Warning')
            onChangePage(e, page - 1)
        }
    }
    const handleNextButtonClick: ClickHandler = (e) => {
        if (typeof onPageChange === 'function') {
            onPageChange(e, page + 1)
        } else {
            console.warn('Mui Deprecation Warning')
            onChangePage(e, page + 1)
        }
    }
    const handleLastPageButtonClick: ClickHandler = (e) => {
        if (typeof onPageChange === 'function') {
            onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
        } else {
            console.warn('Mui Deprecation Warning')
            onChangePage(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
        }
    }

    const disableBackIcons = page === 0
    const disableForwardIcons = page >= Math.ceil(count / rowsPerPage) - 1
    // ElasticSearch doesn't paginate offsets greater than 10k results
    const disableLastPageIcon = disableForwardIcons || count > 10000

    const buttonSize = mobile ? 'small' : 'medium'
    return (
        <Container>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={disableBackIcons}
                aria-label="first page"
                size={buttonSize}
            >
                <FirstPageIcon />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={disableBackIcons}
                aria-label="previous page"
                size={buttonSize}
            >
                <KeyboardArrowLeftIcon />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={disableForwardIcons}
                aria-label="next page"
                size={buttonSize}
            >
                <KeyboardArrowRightIcon />
            </IconButton>
            <Tooltip
                title={count > 10000 ? 'Limit search results to 10K or less to enable last page button' : ''}
                placement="bottom"
            >
                <span>
                    <IconButton
                        onClick={handleLastPageButtonClick}
                        disabled={disableLastPageIcon}
                        aria-label="last page"
                        size={buttonSize}
                    >
                        <LastPageIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </Container>
    )
}

export default TablePaginationActions
